import { tailwindVariants } from '@air/utils-tailwind';

/** Prototype `HeroUserPromptBubble` inner layout — shell chrome lives on `WorkspaceAgentBubble`. */
export const workspaceAgentHeroUserPromptBubble = tailwindVariants({
  slots: {
    description: 'mt-0.5 block min-w-0 text-12 text-gray-10 leading-4',
    icon: 'mt-0.5 shrink-0 text-gray-9',
    root: 'flex w-full items-start gap-2',
    title: 'block min-w-0 font-medium text-12 text-gray-12 leading-4',
  },
});
